import React from "react";
import {AnimateBox} from "../../Components/GenericComponents/AnimateBox";
import {Skeleton} from "../../Components/Skeleton";

export const BlogSkeleton: React.FunctionComponent = () => {
    return (
        <div id="fh5co-blog" className="fh5co-bg-section">
            <div className="container">
                <AnimateBox className="row animate-box row-pb-md" data-animate-effect="fadeInUp">
                    <div className="col-md-8 col-md-offset-2 text-left fh5co-heading">
                        <Skeleton type={"text_title"} />
                    </div>
                </AnimateBox>
                <div className="row">
                    <AnimateBox className="col-xs-12">
                        <Skeleton />
                    </AnimateBox>
                    <AnimateBox className="hidden-xs">
                        <Skeleton />
                    </AnimateBox>
                    <AnimateBox className="hidden-xs">
                        <Skeleton />
                    </AnimateBox>
                </div>
            </div>
        </div>
    )
};